import Vue from 'vue'
import App from './App.vue'
import router from './router'

// 引入重置样式
import '@/style/reset.css'
// 引入全局公共样式
import '@/style/index.css'
// 引入vant按需加载组件
import '@/plugins/vant.js'
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
